export const FreeLimitType = {
  groupLimit: 'groupLimit',
  walletLimit: 'walletLimit',
  scanLimit: 'scanLimit',
  scanWithMultiCurrency: 'scanWithMultiCurrency',
  attachmentWeeklyLimit: 'attachmentWeeklyLimit',
  attachmentSizeLimit: 'attachmentSizeLimit',
  groupActivitySearchOrder: 'groupActivitySearchOrder',
  exportMonthlyLimit: 'exportMonthlyLimit',
  exportFilterLimit: 'exportFilterLimit',
  deviceLimit: 'deviceLimit',
  advancedCharts: 'advancedCharts',
  reportIssue: 'reportIssue',
  webAccess: 'webAccess',
  personalReminderLimit: 'personalReminderLimit',
  recurringExpenses: 'recurringExpenses',
  currencyConversion: 'currencyConversion',
  groupCurrencyConversion: 'groupCurrencyConversion',
  olderAttachmentLimit: 'olderAttachmentLimit',
} as const;

export type FreeLimitType = (typeof FreeLimitType)[keyof typeof FreeLimitType];

export interface UsageCounter {
  readonly count: number;
  readonly limit: number;
  readonly isLimitReached: boolean;
  readonly daysUntilReset?: number | null;
}

export interface AttachmentUsage {
  readonly weekUsed: number;
  readonly weeklyLimit: number;
  readonly isWeeklyLimitReached: boolean;
  readonly daysUntilReset?: number | null;
  readonly maxFileSizeMb: number;
}

export interface ExportUsage {
  readonly monthUsed: number;
  readonly monthlyLimit: number;
  readonly isMonthlyLimitReached: boolean;
  readonly daysUntilReset?: number | null;
}

export interface ScanUsage {
  readonly remaining: number;
  readonly isLimitReached: boolean;
}

export interface ReminderUsage {
  readonly combinedReminders?: UsageCounter | null;
}

export interface PlanUsageModel {
  readonly isPro: boolean;
  readonly groups?: UsageCounter | null;
  readonly wallets?: UsageCounter | null;
  readonly receiptScans?: ScanUsage | null;
  readonly attachments?: AttachmentUsage | null;
  readonly exports?: ExportUsage | null;
  readonly devices?: UsageCounter | null;
  readonly reminders?: ReminderUsage | null;
}
